<!-- 
Dialog showing exception counts by level (debug, error etc)
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <exception-counts-by-level-chart v-if="show">
      <v-card-actions>
        <v-spacer/>
        <v-btn flat @click.prevent="hide">Close</v-btn>
      </v-card-actions>
    </exception-counts-by-level-chart>
  </v-dialog>
</template>

<script>
import ExceptionCountsByLevelChart from "@/components/exception-logs/ExceptionCountsByLevelChart.vue";

export default {
  components: {
    ExceptionCountsByLevelChart
  },
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
